import { Injectable } from '@angular/core';
import * as RolesActions from './roles.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap, tap } from 'rxjs';
import { RolesService } from '../../services/roles.service';
import { catchError } from 'rxjs/operators';
import { updatePermissions } from '../../auth/store/actions/auth.actions';
import { NotificationsService } from '../../core/servises/notifications/notifications.service';

const notificationTranslate = 'rolesPage.notifications.';

@Injectable()
export class RolesEffects {
  public getRoles$ = createEffect(() =>
    this._actions.pipe(
      ofType(RolesActions.getRoles),
      switchMap(() => {
        return this._rolesService.getRoles().pipe(
          switchMap(roles => of(
            RolesActions.getRolesSuccess({ roles }),
          )),
          catchError(() => of(
            RolesActions.getRolesFailed(),
          )),
        )
      }),
    ),
  )

  public getRole$ = createEffect(() =>
    this._actions.pipe(
      ofType(RolesActions.getRole),
      switchMap(({ roleId }) => {
        return this._rolesService.getRole(roleId).pipe(
          switchMap(role => of(
            RolesActions.getRoleSuccess({ role }),
          )),
          catchError(() => of(
            RolesActions.getRoleFailed(),
          )),
        )
      }),
    ),
  )

  public addRole$ = createEffect(() =>
    this._actions.pipe(
      ofType(RolesActions.addRole),
      switchMap(({ roleName, scopes }) => {
        return this._rolesService.addRole(roleName, scopes).pipe(
          tap(() => this._notifications.handleSuccessNotification(`${notificationTranslate}createRole`)),
          switchMap((updatedRole) => of(
            RolesActions.addRoleSuccess({ role: updatedRole }),
          )),
          catchError(() => of(
            RolesActions.addRoleFailed(),
          )),
        )
      }),
    ),
  )

  public updateRole$ = createEffect(() =>
    this._actions.pipe(
      ofType(RolesActions.updateRole),
      switchMap(({ roleId, scopes }) => {
        return this._rolesService.updateRole(roleId, scopes).pipe(
          tap(() => this._notifications.handleSuccessNotification(`${notificationTranslate}updateRole`)),
          switchMap((role) => of(
            RolesActions.updateRoleSuccess({ role }),
            updatePermissions(),
          )),
          catchError(() => of(
            RolesActions.updateRoleFailed(),
          )),
        )
      }),
    ),
  )

  public removeRole$ = createEffect(() =>
    this._actions.pipe(
      ofType(RolesActions.removeRole),
      switchMap(({ roleId }) => {
        return this._rolesService.removeRole(roleId).pipe(
          tap(() => this._notifications.handleSuccessNotification(`${notificationTranslate}removeRole`)),
          switchMap(() => of(
            RolesActions.removeRoleSuccess({ roleId }),
          )),
          catchError(() => of(
            RolesActions.removeRoleFailed(),
          )),
        )
      }),
    ),
  )

  constructor(
    private _actions: Actions,
    private _rolesService: RolesService,
    private _notifications: NotificationsService,
  ) {}
}
